import { createSelector } from 'reselect';
import { getShelvesForCurrentUser } from './ShelfSelector';
import Immutable from 'immutable';

const borrowingHistory = state => state.getIn(['borrowing', 'borrowingHistory'], Immutable.Map());
const currentItemIds = state => state.getIn(['borrowing', 'borrowingHistory', 'results'], Immutable.List());
const allRecentlyReturned = state => state.getIn(['entities', 'borrowingHistory'], Immutable.Map());
const allBibs = state => state.getIn(['entities', 'bibs'], Immutable.Map());

export const getBorrowingHistoryData = createSelector(
  [borrowingHistory],
  (data) => data
);

export const getRecentlyReturnedWithBibs = createSelector(
  currentItemIds,
  allRecentlyReturned,
  allBibs,
  getShelvesForCurrentUser,
  (itemIds, itemsById, bibs, shelfItems) => {
    const recentReturns = itemIds
      .map(id => itemsById.get(id))
      .filter(item => !!item)
      .map(recentReturn => recentReturn.set('bib', bibs.get(recentReturn.get('metadataId'))))
      .map(recentReturn => {
        const isAlreadyOnShelf = shelfItems.some(
          (item) => (item.get('metadataId') === recentReturn.get('metadataId'))
        );

        const canAddToShelf = recentReturn.get('bib') && !isAlreadyOnShelf;

        const actions = canAddToShelf ?
          recentReturn.get('actions', Immutable.List()).push('addToShelf') :
          recentReturn.get('actions');

        return recentReturn.set('actions', actions);
      })
      .toList();

    return recentReturns;
  }
);


export default {
  getRecentlyReturnedWithBibs,
  getBorrowingHistoryData
};



// WEBPACK FOOTER //
// ./app/selectors/RecentlyReturnedSelector.js